import {
  REQUEST_MOSQUES, RECEIVE_MOSQUES, RECEIVE_MOSQUE,
} from '../actions/mosques';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_MOSQUES:
      return { ...state, loading: true };
    case RECEIVE_MOSQUES:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_MOSQUE:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
